import { render, staticRenderFns } from "./GridBody.vue?vue&type=template&id=46989df3&scoped=true"
import script from "./GridBody.vue?vue&type=script&lang=js"
export * from "./GridBody.vue?vue&type=script&lang=js"
import style0 from "./GridBody.vue?vue&type=style&index=0&id=46989df3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46989df3",
  null
  
)

export default component.exports